import LoaderImg from '../../assets/logo.png'

export default function Loader() {
    return(
        <div className='loader'>
            <img src={LoaderImg} alt="loaderImg" />
        </div>
    )
}
